import { Injectable, Inject } from '@angular/core';
import { Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Trascodifica, StaticUrls } from '../models';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { MyCookieService } from './my-cookie.service';
import { AuthHttp, tokenNotExpired } from 'angular2-jwt';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';

/**
 * @export
 * @class TrascodificaService
 */
@Injectable()
export class TrascodificaService {
  
  private trascodifiche: Trascodifica[];
  private headers = new Headers({ 'Content-Type': 'application/json' });
  private options = new RequestOptions({ headers: this.headers });

  constructor(private http: AuthHttp,
    private router: Router,
    @Inject(MyCookieService) private myCookieService: MyCookieService) { }

  /**
   * Il servizio non è profilato
   * @returns {Observable<Trascodifica[]>} elenco Trascodifiche 'Tipologia Profilo Utente'
   * @memberof TrascodificaService
   */
  getProfilo(): Observable<Trascodifica[]> {
    return this.get('Tipologia Profilo Utente');
  }

  /**
   * Il servizio non è profilato
   * @returns {Observable<Trascodifica[]>} elenco Trascodifiche 'Stato WF Immobile'
   * @memberof TrascodificaService
   */
  getStatoPubblicita(): Observable<Trascodifica[]> {
    return this.get('Stato WF Immobile');
  }

  /**
   * Il servizio non è profilato
   * @returns {Observable<Trascodifica[]>} elenco Trascodifiche 'Tipologia Immobile'
   * @memberof TrascodificaService
   */
  getTipologiaImmobile(): Observable<Trascodifica[]> {
    return this.get('Tipologia Immobile');
  }

  /**
   * Il servizio non è profilato
   * @returns {Observable<Trascodifica[]>} elenco Trascodifiche 'Stato Blocco Immobile'
   * @memberof TrascodificaService
   */
  getStatoBloccoImmobile(): Observable<Trascodifica[]> {
    return this.get('Stato Blocco Immobile');
  }

  /**
   * Il servizio non è profilato
   * @returns {Observable<Trascodifica[]>} elenco Trascodifiche 'Tipologia Contratto Immobile'
   * @memberof TrascodificaService
   */
  getContrattoImmobile(): Observable<Trascodifica[]> {
    return this.get('Tipologia Contratto Immobile');
  }

  /**
   * Il servizio non è profilato
   * @returns {Observable<Trascodifica[]>} elenco Trascodifiche 'Dati Catastali Immobile'
   * @memberof TrascodificaService
   */
  getDatiCatastali(): Observable<Trascodifica[]> {
    return this.get('Dati Catastali Immobile');
  }

  /**
   * Il servizio non è profilato
   * @returns {Observable<Trascodifica[]>} elenco Trascodifiche 'Categoria Catasto Immobile'
   * @memberof TrascodificaService
   */
  getCategoriaCatasto(): Observable<Trascodifica[]> {
    return this.get('Categoria Catasto Immobile');
  }

  /**
   * Il servizio non è profilato
   * @returns {Observable<Trascodifica[]>} elenco Trascodifiche 'Categoria Immobile'
   * @memberof TrascodificaService
   */
  getCategoria(): Observable<Trascodifica[]> {
    return this.get('Categoria Immobile');
  }
  
  /**
   * Il servizio non è profilato
   * @returns {Observable<Trascodifica[]>}
   * @memberof TrascodificaService
   */
  getConsistenzaCatastali(): Observable<Trascodifica[]> {
    return this.get('Consistenza Catastale Immobile');
  }
  /**
   * Il servizio non è profilato
   * @returns {Observable<Trascodifica[]>}
   * @memberof TrascodificaService
   */
  getServiziImmobile(): Observable<Trascodifica[]> {
    return this.get('Servizio Immobile');
  }

  /**
   * Il servizio non è profilato
   * @returns {Observable<Trascodifica[]>} elenco Trascodifiche 'Tipologia Proprieta Immobile'
   * @memberof TrascodificaService
   */
  getTipologiaProprieta(): Observable<Trascodifica[]> {
    return this.get('Tipologia Proprieta Immobile');
  }

  /**
   * Il servizio non è profilato
   * @returns {Observable<Trascodifica[]>}
   * @memberof TrascodificaService
   */
  getDisponibilita(): Observable<Trascodifica[]> {
    return this.get('Disponibilita Immobile');
  }
  
  /**
   * Il servizio è profilato
   * @returns {Observable<Trascodifica[]>}
   * @memberof TrascodificaService
   */
  getClasseEnergetica(): Observable<Trascodifica[]> {
    return this.getParentWithChildren('Categoria Classe Energetica');
  }

  /**
   * Il servizio è profilato
   * @returns {Observable<Trascodifica[]>}
   * @memberof TrascodificaService
   */
  getClasseEnergeticaWithParent(): Observable<Trascodifica[]> {
    return this.getParentWithParent('Classe Energetica');
  }

  /**
   * Il servizio non è profilato
   * @returns {Observable<Trascodifica[]>}
   * @memberof TrascodificaService
   */
  getRiscaldamento(): Observable<Trascodifica[]> {
    return this.get('Riscaldamento Immobile');
  }

  /**
   * Il servizio non è profilato
   * @returns {Observable<Trascodifica[]>}
   * @memberof TrascodificaService
   */
  getStatoImmobile(): Observable<Trascodifica[]> {
    return this.get('Stato Immobile');
  }

  /**
   * Il servizio non è profilato
   * @returns {Observable<Trascodifica[]>}
   * @memberof TrascodificaService
   */
  getClimatizzatore(): Observable<Trascodifica[]> {
    return this.get('Climatizzatore Immobile');
  }

  /**
   * Il servizio non è profilato
   * @returns {Observable<Trascodifica[]>}
   * @memberof TrascodificaService
   */
  getCucina(): Observable<Trascodifica[]> {
    return this.get('Tipologia Cucina');
  }

  /**
   * Il servizio non è profilato
   * @returns {Observable<Trascodifica[]>}
   * @memberof TrascodificaService
   */
  getBox(): Observable<Trascodifica[]> {
    return this.get('Tipologia Box');
  }

  /**
   * Il servizio non è profilato
   * @returns {Observable<Trascodifica[]>}
   * @memberof TrascodificaService
   */
  getInfissi(): Observable<Trascodifica[]> {
    return this.get('Tipologia Infissi');
  }

  /**
   * Il servizio non è profilato
   * @returns {Observable<Trascodifica[]>}
   * @memberof TrascodificaService
   */
  getTipologiePosizioneCandidato(){
    return this.get('Tipologia Posizione Candidato');
  }

  /**
   * Il servizio non è profilato
   * @returns {Observable<Trascodifica[]>}
   * @memberof TrascodificaService
   */
  getCircuitoCartaCredito(){
    return this.get('Circuito Carta di Credito');
  }

  /**
   * Il servizio non è profilato
   * @returns {Observable<Trascodifica[]>}
   * @memberof TrascodificaService
   */
  getStatoCollaboratore(): Observable<Trascodifica[]> {
    return this.get('Stato Collaboratore');
  }

  /**
   * Il servizio non è profilato
   * @returns {Observable<Trascodifica[]>}
   * @memberof TrascodificaService
   */
  get(dominio: string, orderFieldName?: string): Observable<Trascodifica[]> {
    
    return this.http.get(StaticUrls._getTrascodifica(dominio,orderFieldName))
      .map(this.extractDataList)
      .catch(this.handleError);
  }

  /**
   * Il servizio non è profilato
   * @returns {Observable<Trascodifica[]>}
   * @memberof TrascodificaService
   */
  getParentWithChildren(dominio: string, descrizione?: string): Observable<Trascodifica[]> {
    return this.http.get(StaticUrls._getTrascodificaWithChildren(dominio,descrizione), this.options)
      .map(this.extractDataList)
      .catch(this.handleError);
  }

  /**
   * Il servizio non è profilato
   * @returns {Observable<Trascodifica[]>}
   * @memberof TrascodificaService
   */
  getParentWithParent(dominio: string, descrizione?: string): Observable<Trascodifica[]> {
    return this.http.get(StaticUrls._getTrascodificaWithParent(dominio,descrizione), this.options)
      .map(this.extractDataList)
      .catch(this.handleError);
  }

  /**
   * Il servizio non è profilato
   * @returns {Observable<Trascodifica[]>}
   * @memberof TrascodificaService
   */
  getMore(dominio: Array<string>, orderFieldName?: string): Observable<Trascodifica[]> {
    return this.http.post(StaticUrls._getTrascodificaMore(orderFieldName), JSON.stringify(dominio), this.options)
      .map(this.extractDataList)
      .catch(this.handleError);
  }

  /**
   * Il servizio non è profilato
   * @returns {Observable<Trascodifica>}
   * @memberof TrascodificaService
   */
  getById(id: number): Observable<Trascodifica> {
    
    return this.http.get(StaticUrls._getTrascodificaById(id))
      .map(this.extractDataObj)
      .catch(this.handleError);
  }
  
  /**
   * Il servizio non è profilato
   * @returns {Observable<number>}
   * @memberof TrascodificaService
   */
  getIdByDominioAndDescrizione(dominio: string, descrizione: string): Observable<number> {
    
    return this.http.get(StaticUrls._getIdDominioAndDescrizione(dominio, descrizione))
      .map(this.extractDataObj)
      .catch(this.handleError);
  }

  private extractDataObj(res: Response) {
    return res.json();
  }

  private extractDataList(res: Response) {
    this.trascodifiche = res.json();
    return this.trascodifiche;
  }

  private handleError(error: Response | any) {
    let errMsg: string;

    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }

}



// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/services/trascodifica.service.ts